var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { convertToCSSValue, getGeometryStyle, getMinimumHeight, getMinimumWidth, } from '../../helpers/styles';
import { isTrue } from '../../helpers/utils';
import Column from '../Column';
import Item from '../Item';
import gridData from './gridData';
export var StyledTableContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  overflow-y: ", ";\n  position: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-color: ", ";\n  border-collapse: ", ";\n  border-spacing: ", ";\n"], ["\n  ", "\n  overflow-y: ", ";\n  position: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  height: ",
    ";\n  width: ",
    ";\n  background-color: ",
    ";\n  border: ",
    ";\n  border-color: ", ";\n  border-collapse: ",
    ";\n  border-spacing: ",
    ";\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.overflow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.position;
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumHeight(minimumSize);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumWidth(minimumSize);
}, function (_a) {
    var _b = _a.attributes, geometry = _b.geometry, minimumSize = _b.minimumSize, windowTheme = _a.windowTheme;
    var _c, _d;
    return (_d = (_c = geometry === null || geometry === void 0 ? void 0 : geometry.height) !== null && _c !== void 0 ? _c : getMinimumHeight(minimumSize)) !== null && _d !== void 0 ? _d : windowTheme.dataGrid.table.height;
}, function (_a) {
    var _b = _a.attributes, geometry = _b.geometry, minimumSize = _b.minimumSize, windowTheme = _a.windowTheme;
    return (geometry === null || geometry === void 0 ? void 0 : geometry.width) ? geometry.width
        : getMinimumWidth(minimumSize) || windowTheme.dataGrid.table.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.border) !== null && _b !== void 0 ? _b : windowTheme.dataGrid.table.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.borderColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.borderCollapse;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.borderSpacing;
});
export var StyledTable = styled.table.attrs(function (props) { })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  color: ", ";\n\n  > thead > tr {\n    height: ", ";\n    width: ", ";\n    table-layout: ", ";\n  }\n\n  > thead > tr > th {\n    position: ", ";\n    top: ", ";\n    background-color: ", ";\n    font-weight: ", ";\n    text-align: ", ";\n  }\n  > thead > tr > th,\n  tbody > tr > th {\n    border: ", ";\n    border-left-color: ", ";\n    border-top-color: ", ";\n  }\n  > tbody {\n    color: ", ";\n  }\n  > tbody > tr {\n    border-left: ", ";\n    height: ", ";\n    width: ", ";\n    table-layout: ", ";\n  }\n  > tbody > tr > td {\n    border: ", ";\n    border-left: ", ";\n    border-top: ", ";\n    cursor: ", ";\n  }\n  tr > th[scope='row'] {\n    display: ", ";\n    color: ", ";\n    background-color: ", ";\n    text-align: ", ";\n    width: ", ";\n  }\n"], ["\n  width: ", ";\n  color: ", ";\n\n  > thead > tr {\n    height: ", ";\n    width: ", ";\n    table-layout: ",
    ";\n  }\n\n  > thead > tr > th {\n    position: ",
    ";\n    top: ", ";\n    background-color: ",
    ";\n    font-weight: ",
    ";\n    text-align: ",
    ";\n  }\n  > thead > tr > th,\n  tbody > tr > th {\n    border: ",
    ";\n    border-left-color: ",
    ";\n    border-top-color: ",
    ";\n  }\n  > tbody {\n    color: ", ";\n  }\n  > tbody > tr {\n    border-left: ",
    ";\n    height: ", ";\n    width: ", ";\n    table-layout: ",
    ";\n  }\n  > tbody > tr > td {\n    border: ",
    ";\n    border-left: ",
    ";\n    border-top: ",
    ";\n    cursor: ",
    ";\n  }\n  tr > th[scope='row'] {\n    display: ",
    ";\n    color: ", ";\n    background-color: ",
    ";\n    text-align: ",
    ";\n    width: ",
    ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.tableLayout;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.fontWeight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.textAlign;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.borderLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.borderTop;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.borderLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.tableLayout;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.border) !== null && _b !== void 0 ? _b : windowTheme.dataGrid.table.tbody.tr.td.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.td.borderLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.td.borderTop;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.td.cursor;
}, function (_a) {
    var verticalHeaderVisible = _a.verticalHeaderVisible;
    return verticalHeaderVisible ? 'table-cell' : 'none';
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.tbody.tr.th.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.rowHeader.textAlign;
}, function (_a) {
    var verticalHeaderMaximumSectionSize = _a.verticalHeaderMaximumSectionSize;
    return verticalHeaderMaximumSectionSize
        ? convertToCSSValue(verticalHeaderMaximumSectionSize)
        : 'auto';
});
export var StyledTr = styled.tr.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n"], ["\n  color: ",
    ";\n  background-color: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme, isSelectedRow = _a.isSelectedRow, fontColor = _a.fontColor;
    return isSelectedRow
        ? windowTheme.dataGrid.table.tbody.tr.selectedFontColor
        : fontColor !== null && fontColor !== void 0 ? fontColor : '';
}, function (_a) {
    var windowTheme = _a.windowTheme, isSelectedRow = _a.isSelectedRow, backgroundColor = _a.backgroundColor;
    return isSelectedRow
        ? windowTheme.dataGrid.table.tbody.tr.selectedBgColor
        : backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : '';
});
var DataGridColumn = function (props) {
    var column = props.column, rowData = props.rowData, rowIndex = props.rowIndex, otherValues = props.otherValues, restProps = __rest(props, ["column", "rowData", "rowIndex", "otherValues"]);
    if (rowData && rowData.length > 0) {
        return column.map(function (col, index) {
            var _a;
            var colData = rowData.find(function (c) {
                return c.column == index.toString();
            });
            return (React.createElement(Item, __assign({ parentWidget: restProps, type: "item", otherValues: otherValues, colId: (_a = col === null || col === void 0 ? void 0 : col.attributes) === null || _a === void 0 ? void 0 : _a.text, rowIndex: rowIndex }, colData)));
        });
    }
    return null;
};
var DataGridBody = function (props) {
    var _a = useState(-1), selectedRow = _a[0], updateSelectedRow = _a[1];
    var _onRowSelect = useContext(WindowEventContext)._onRowSelect;
    var row = props.row, identifier = props.identifier, item = props.item, rowHeaders = props.rowHeaders, restProps = __rest(props, ["row", "identifier", "item", "rowHeaders"]);
    var rowsCount = (row && Array.isArray(row) && row.length) || 0;
    var itemCount = (item && item.length) || 0;
    if (rowsCount > 0) {
        return row
            .filter(function (r) { return !isTrue(r.deleted); })
            .map(function (r, index) {
            var _a, _b, _c;
            var gridData = item && item.filter(function (i) { return i.row === index.toString(); });
            var attributes = r.attributes, selected = r.selected, rowNumber = r.rowNumber, fontColor = r.fontColor, backgroundColor = r.backgroundColor, restValues = __rest(r, ["attributes", "selected", "rowNumber", "fontColor", "backgroundColor"]);
            var _d = (attributes || {}).text, text = _d === void 0 ? '' : _d;
            var actualRowIndex = rowNumber ? +rowNumber : index;
            var isSelectedRow = isTrue(selected);
            return (React.createElement(StyledTr, __assign({ id: identifier + "_row_" + index, key: identifier + "-row-" + index, fontColor: fontColor, backgroundColor: backgroundColor, isSelectedRow: isSelectedRow, onClick: function (e) {
                    _onRowSelect(identifier, actualRowIndex, !isSelectedRow);
                } }, restProps, { type: "row" }),
                React.createElement("th", { scope: "row" }, (_c = (text || ((_b = (_a = rowHeaders === null || rowHeaders === void 0 ? void 0 : rowHeaders[index]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.text))) !== null && _c !== void 0 ? _c : ''),
                React.createElement(DataGridColumn, __assign({ identifier: identifier, rowData: gridData, otherValues: restValues, rowIndex: index }, restProps))));
        });
    }
    else {
        if (item && itemCount > 0) {
            return __spreadArrays(Array(itemCount)).map(function (x, index) {
                var gridData = item.filter(function (i) { return i.row === index.toString(); });
                var isSelectedRow = selectedRow === index;
                return (React.createElement(StyledTr, __assign({ id: identifier + "_row_" + index, key: identifier + "-row-" + index, fontColor: item.fontColor, backgroundColor: item.backgroundColor, isSelectedRow: isSelectedRow, onClick: function (e) {
                        _onRowSelect(identifier, index, !isSelectedRow);
                        updateSelectedRow(index);
                    } }, restProps, { type: "row" }),
                    React.createElement(DataGridColumn, __assign({ identifier: identifier, rowIndex: index, rowData: gridData }, restProps))));
            });
        }
        return null;
    }
};
var DataGrid = function (props) {
    var fields = useContext(WindowStateContext).fields;
    var identifier = props.identifier, row = props.row, column = props.column, item = props.item, attributes = props.attributes, parentWidget = props.parentWidget, className = props.className, restProps = __rest(props, ["identifier", "row", "column", "item", "attributes", "parentWidget", "className"]);
    var _a = gridData(fields, item, column, identifier), itemData = _a.itemData, rowData = _a.rowData;
    var verticalHeaderVisible = attributes.verticalHeaderVisible, minimumSize = attributes.minimumSize, verticalHeaderMaximumSectionSize = attributes.verticalHeaderMaximumSectionSize;
    verticalHeaderVisible =
        typeof verticalHeaderVisible !== 'undefined'
            ? isTrue(verticalHeaderVisible)
            : false;
    var columnsCount = (column && Array.isArray(column) && column.length) || 0;
    return (React.createElement(StyledTableContainer, __assign({}, minimumSize, { attributes: attributes }, restProps),
        React.createElement(StyledTable, __assign({ id: identifier }, className, restProps, { attributes: attributes, verticalHeaderVisible: verticalHeaderVisible, verticalHeaderMaximumSectionSize: verticalHeaderMaximumSectionSize }),
            React.createElement("thead", null,
                React.createElement(StyledTr, { type: "row" },
                    React.createElement("th", { scope: "row" }),
                    columnsCount > 0 &&
                        column.map(function (col, index) {
                            var attributes = col.attributes;
                            return (React.createElement(Column, __assign({ key: identifier + "_col_" + index, notHeader: "false", id: identifier + "_col_" + index }, restProps, { type: "column", attributes: attributes })));
                        }))),
            React.createElement("tbody", null,
                React.createElement(DataGridBody, __assign({ row: rowData, identifier: identifier, item: itemData }, restProps, { column: column, rowHeaders: row }))))));
};
export default DataGrid;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map